function delayedWatchItem (mixin, watchedAttr, watchOpts) {
  if (typeof watchedAttr !== 'string' && !process.env.PROD) {
    // eslint-disable-next-line no-console
    return;
  }
  let watchHandler;
  let watchTimeout;
  if (typeof watchOpts === 'string') {
    watchHandler = watchOpts;
  } else if (typeof watchOpts === 'function') {
    watchHandler = watchOpts;
  } else if (typeof watchOpts === 'object') {
    watchHandler = watchOpts.handler;
    watchTimeout = watchOpts.timeout;
  }

  let lazyHandler;
  if (typeof watchHandler !== 'string' && typeof watchHandler !== 'function' && !process.env.PROD) {
    // eslint-disable-next-line no-console
    return;
  } else if (typeof watchHandler === 'string') {
    lazyHandler = function () {
      this[watchHandler]();
    };
  } else {
    lazyHandler = function () {
      watchHandler.call(this, this[watchedAttr]);
    };
  }
  watchTimeout = watchTimeout || 300;

  const timerAttrName = watchedAttr + '_timer';
  mixin.data[timerAttrName] = undefined;
  mixin.watch[watchedAttr] = {
    handler () {
      if (this[timerAttrName]) {
        clearTimeout(this[timerAttrName]);
      }
      this[timerAttrName] = setTimeout(lazyHandler.bind(this), watchTimeout);
    },
    immediate: !!watchOpts.immediate,
  };
}

export default function delayedWatch (opts) {
  if (typeof opts !== 'object')
    return;
  let mixin;
  for (const [watchedAttr, watchedOpts] of Object.entries(opts)) {
    delayedWatchItem((mixin || (mixin = { data: {}, watch: {}, })), watchedAttr, watchedOpts);
  }
  if (!mixin || Object.keys(mixin).length === 0)
    return;
  var mixinData = mixin.data;
  return {
    data () {
      return mixinData;
    },
    watch: mixin.watch,
  };
}
